import React from 'react';

function StepIndicator({ currentStep }) {
  const steps = [
    { number: 1, label: 'Peserta' },
    { number: 2, label: 'S&K' },
    { number: 3, label: 'Jadwal' }
  ];

  return (
    <div className="step-indicator">
      {steps.map((step, index) => (
        <div 
          key={step.number} 
          className={`step ${currentStep === step.number ? 'active' : ''} ${currentStep > step.number ? 'completed' : ''}`}
        >
          <div className="step-circle">{step.number}</div>
          <div className="step-label">{step.label}</div>
        </div>
      ))}
    </div>
  );
}

export default StepIndicator;